import PropTypes from 'prop-types';
import Modal from '../../../components/Modal';
import { Button } from 'react-bootstrap';
import ActivityTypes from '../../../enums/activityTypes';

const AssignmentsUsedBy = ({ usedAssignments, showUsedByModal, setShowUsedByModal, activityType = ActivityTypes.Assignment }) => {
  return (
    <Modal
      isOpen={showUsedByModal}
      onClose={() => setShowUsedByModal(false)}
      titleName={`${activityType == ActivityTypes.FlashCard ? 'Flashcards Using this vocabulary Term' : 'Assignments Using this Question'}`}
      contentWidth='40%'>
      <div className='d-flex custom-table flex-column'>
        <table className='table list-table'>
          <thead>
            <tr>
              <th>{activityType == ActivityTypes.Assignment ? 'Assignment' : 'Flashcard'}</th>
              <th>Course</th>
            </tr>
          </thead>
          <tbody>
            {usedAssignments?.map((usedBy, index) => {
              return (
                <tr key={`assignmentRow_${index}`}>
                  <td>{usedBy.assignmentName}</td>
                  <td>{usedBy.courseName}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className='d-flex flex-row justify-content-end mt-4'><Button variant='castleRed' className='w-25' onClick={() => setShowUsedByModal(false)}>Ok</Button></div>
      </div>
    </Modal>
  );
};
AssignmentsUsedBy.propTypes = {
  usedAssignments: PropTypes.array.isRequired,
  showUsedByModal:PropTypes.bool,
  setShowUsedByModal:PropTypes.func,
  activityType: PropTypes.number
};

export default AssignmentsUsedBy;
